<div class="clearfix">
    <p class="title fl">编辑资料</p>
    <span class="op-btn light-btn fr" id="saveProfileBtn">保存</span>
</div>
<form class="layui-form">

    <div class="form-data-item">
        <label class="form-label" style="">头像</label>
        <div class="" style="display: inline-block;border: none;vertical-align: middle;">
            <div id="headUpload">
                <div class="upload-mask">编辑头像</div>
                {{if IsWaitAudit ==1 }}
                    <span class="audit">审核中…</span>
                {{/if}}
            </div>
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">考米号</label>
        <div class="form-block" style="border: none">
            {{MeterNo}}
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">昵称</label>
        <div class="form-block">
            <input type="text" value="{{NickName}}" id="pNickName">
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">性别</label>
        <div class="form-block" style="border: none;color: #999">
            {{if Sex == 1}}
                男
            {{else}}
                女
            {{/if}}
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">生日</label>
        <div class="form-block">
            <input type="text" id="mpbirthday" value="">
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">所在地</label>
        <div class="form-block" style="width:130px">
            <select name="mpprovince" lay-filter="mpprovince"></select>
        </div>
        <div class="form-block" style="width:130px;margin-left: 10px;">
            <select name="mpcity" lay-filter="mpcity"></select>
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">学历</label>
        <div class="form-block">
            <select name="mpedu" lay-filter="mpedu"></select>
        </div>
    </div>
    {{if RoleID != 4}}
        <div class="form-data-item">
            <label class="form-label">情感状态</label>
            <div class="form-block">
                <select name="mpemotion" lay-filter="mpemotion"></select>
            </div>
        </div>
        <div class="form-data-item">
            <label class="form-label">身高</label>
            <div class="form-block" style="margin-right: 5px;">
                <input type="text" id="mHeight" value="{{Height}}">
            </div>CM
        </div>
        <div class="form-data-item">
            <label class="form-label">月薪</label>
            <div class="form-block">
                <select name="mMonthSalary" lay-filter="monthSalary"></select>
            </div>
        </div>
    {{/if}}

    {{if RoleID!=1 }}
        <div class="form-data-item">
            <label class="form-label">特长</label>
            <div class="form-inline-block speciality" style="border: none">
                {{each Specialty item}}
                    <span class="mr10">{{item}}</span>
                {{/each}}
                <h4 class="txt-btn" onclick="openSpecialityCon()">修改</h4>
            </div>
        </div>
    {{/if}}
    <div class="form-data-item">
        <label class="form-label">声音名片</label>
        <div class="form-block voice-card" style="border: none;padding: 0;">
            {{if VoiceLength > 0}} 
                <audio id="audioPlayer"></audio>
                <div class="voice-box mr10" data-media={{VoiceUrl}} data-time={{VoiceLength}} onclick="playVoice(this)">
                    <div class="rhythm_box">
                        <span class="line2"></span>
                        <span class="line3"></span>
                        <span class="line4"></span>
                    </div>
                    <div class="pause_rhythm">
                        <span class="line2"></span>
                        <span class="line3"></span>
                        <span class="line4"></span>
                    </div>
                    <label class="timeL" style="font-size: 14px;color: #fff;padding-left: 35px;" data-ctime={{VoiceLength}}>{{transMediaLength}}</label>
                    {{if IsVoiceWaitAudit==0}}
                    <!--审核中-->
                        <img class="verifyStateImg" src="../../../public/images/voice-verify.png">
                    {{/if}}
                </div>
                <h4 class="txt-btn">修改</h4>
            {{else }}
                <a class="addVoiceBtn themeColor">添加声音名片</a>
            {{/if}}
        </div>
    </div>
    <div class="form-data-item">
        <label class="form-label">个性签名</label>
        <div class="textarea-con" style="display: inline-block;vertical-align: middle;">
            <textarea class="layui-textarea" id="personalSignature">
            </textarea>
            {{if IsTipsWaitAudit == 0}}
                <img class="verifyStateImg" src="../../../public/images/sign-verify.png">
            {{/if}}
        </div>
    </div>
</form>

<div id="headUpload-con">
    <div class="headUpload-sel-con">
        <div id="headUpload-sel">
            +选择图片
        </div>
        <ul>
            <li>1、头像要求清晰，照片不含色情，暴力广告联系方式；</li>
            <li>2、请勿上传宠物，明星照，卡通人物等非本人照片；</li>
            <li>3、照片格式为jpg、png、gif大小不超过6MB；</li>
            <li>4、提交审核后客服将在24小时内审核，请耐心等待。</li>
        </ul>
    </div>

    <div class="btn-wrap">
        <a class="btn-confirm" id="uploadimg-btn">上传</a>
    </div>
</div>

<div id="voiceUpload-con">
    <div class="voiceUpload-sel-con">
        <div id="voiceUpload-sel">
            +选择音频
        </div>
        <div class="layui-upload-list">
            <table class="layui-table">
            <thead>
                <tr><th>文件名</th>
                <th>大小</th>
                <th>状态</th>
                <th>操作</th>
            </tr></thead>
            <tbody id="voiceList"></tbody>
            </table>
        </div>
        <ul>
            <li>1、音频时长：5~60s；</li>
            <li>2、格式要求：MP3、WAV、WMA、APE，大小10MB以内；</li>
            <li>3、提交审核后客服将在24小时内审核，请耐心等待。</li>
        </ul>
    </div>

    <div class="btn-wrap">
        <a class="btn-confirm" id="uploadvoice-btn">上传</a>
    </div>
</div>

<div id="speciality-con">
    <div class="ui-dialog-title clearfix">
        <p>特长</p>
        <h4>请选择1~3项特长</h4>
    </div>
    <div class="labelList-con clearfix">
        {{each specialityList item index}}
            <span class="label fl mr10 mb10" data-id={{item.TypeValue}}>{{item.TypeName}}</span>
        {{/each}}
    </div>
    
    <div class="btn-wrap">
        <a class="btn-confirm" id="setSpecialty">确认</a>
    </div>

</div>